import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'
import { ILanguage } from 'static/languages'

export interface IRegisterData {
  providerUserToken: string
  preferredCurrency: number
  timezone: number
  visitorId: string
  language?: ILanguage['locale']
  clickId?: string
  offer?: string
  partnerId?: string
  gaClickId?: string
  referral?: string
}

const registerByFacebook = (data: IRegisterData): AxiosPromise =>
  apiFetch(`/socialauth/register/facebook`, { data, method: `POST` })

export default registerByFacebook
